import React, { useState } from 'react';
import styles from '../PatientProfileV2.module.scss';
import { UserEditedMeta } from './PatientProfileInformation';
import Text from '../../Base/Text/Text';
import { Theme } from '../../../Enums/Theme.enum';
import LinkButton from '../../Button/LinkButton';
import apiClient from '../../../Services/ApiClient';
import useNotification from '../../../Hooks/useNotification.hook';
import useApiClient from '../../../Modules/Base/Hooks/useApiClient';
import MediaViewerModal from '../../MediaViewer/MediaViewerModal';
import useTranslation from '../../../Hooks/useTranslation';
import useLoading from '../../../Modules/Base/Hooks/useLoading';

interface Props {
	user: UserEditedMeta;
}

const PatientProfileMouNumber: React.FC<Props> = ({ user }) => {
	const { showNotificationSuccess } = useNotification();
	const { displayError } = useApiClient();
	const numberId = user.partnerIdentifier;
	const [file, setFile] = useState(undefined);
	const { t } = useTranslation();
	const { isLoading: isLoadingPrint, setIsLoading: setIsLoadingPrint } =
		useLoading(false);
	const { isLoading: isLoadingSms, setIsLoading: setIsLoadingSms } =
		useLoading(false);
	const { isLoading: isLoadingEmail, setIsLoading: setIsLoadingEmail } =
		useLoading(false);

	const handleSendMouNumberByEmail = async () => {
		if (numberId) {
			setIsLoadingEmail(true);
			try {
				const response = await apiClient.get(
					`/user/number-p/${numberId}/send-email/${user.email}`,
				);
				if (response.status === 200) {
					showNotificationSuccess({
						content: t(
							'component.patientProfileMouNumber.codeHasBeenSendToPatientsEmail',
						),
					});
				}
			} catch (e: any) {
				displayError(e);
			}
			setIsLoadingEmail(false);
		}
	};

	const handleSendMouNumberBySms = async () => {
		if (numberId) {
			setIsLoadingSms(true);
			try {
				const response = await apiClient.get(
					`/user/number-p/${numberId}/send-sms/${user.phoneNumber}`,
				);
				if (response.status === 200) {
					showNotificationSuccess({
						content: t(
							'component.patientProfileMouNumber.codeHasBeenSendToPatientsPhone',
						),
					});
				}
			} catch (e: any) {
				displayError(e);
			}
			setIsLoadingSms(false);
		}
	};

	const handlePrintMouNumber = async () => {
		if (numberId) {
			setIsLoadingPrint(true);
			try {
				const response = await apiClient.get(
					`/user/number-p/${numberId}/print/`,
				);
				console.log('response', response);
				if (response.status === 200) {
					console.log('response?.data?.url', response?.data?.url);
					setFile(response?.data?.url);
				}
			} catch (e: any) {
				displayError(e);
			}
			setIsLoadingPrint(false);
		}
	};

	if (!user.partnerIdentifier) {
		return <></>;
	}

	return (
		<div className={styles.item}>
			<Text className={styles.name} tx='base.shared.mouNumber' firstUpper />
			<div className={styles.code}>{user.partnerIdentifier}</div>
			<div className={styles.buttons}>
				<LinkButton
					title='component.patientRegistrationStep2.printRegistrationCode'
					theme={Theme.BLUE}
					onClick={handlePrintMouNumber}
					isLoading={isLoadingPrint}
				/>
				<LinkButton
					title='component.patientRegistrationStep2.sendCodeToEmail'
					theme={Theme.BLUE}
					onClick={handleSendMouNumberByEmail}
					isLoading={isLoadingEmail}
				/>
				<LinkButton
					title='component.patientRegistrationStep2.sendCodeToPhone'
					theme={Theme.BLUE}
					onClick={handleSendMouNumberBySms}
					isLoading={isLoadingSms}
				/>
			</div>
			{file && (
				<MediaViewerModal
					opened={!!file}
					onClose={() => setFile(undefined)}
					file={{
						id: '',
						download: file,
						preview: file,
						type: 'pdf',
						displayName: user.partnerIdentifier ?? '',
					}}
				/>
			)}
		</div>
	);
};

export default PatientProfileMouNumber;
